import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { loadServices, loadSubpages, setUISettings } from './store/actions/app.actions';
import { DeviceDetectorService } from './services/device-detector.service';
import {
  DownloadApplicationDialogComponent
} from './components/download-application-dialog/download-application-dialog.component';
import { selectUISettings } from './store/selectors/app.selectors';
import { SessionService } from './services/ssession.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    DownloadApplicationDialogComponent
  ],
  template: `
    <app-download-application-dialog
      #downloadAppDialog>
    </app-download-application-dialog>
    <router-outlet />
  `,
  providers: []
})
export class AppComponent implements OnInit {

  @ViewChild('downloadAppDialog', { static: true })
  public downloadAppDialog: DownloadApplicationDialogComponent | undefined;

  private url: URL = new URL(window.location.href);

  // for hiding content
  private embed = this.url.searchParams.get('embed');


  // only for dialog
  private fromMobile = this.url.searchParams.get('mobile');

  constructor(
    private store$: Store,
    private deviceDetector: DeviceDetectorService
  ) {
    this.store$.dispatch(loadServices());
    this.store$.dispatch(loadSubpages());
  }

  private handleRouteParams(): void {
    if (!this.deviceDetector.isMobile()) {
      return;
    }
    switch (true) {
      case this.embed === 'true': {
        this.store$.dispatch(
          setUISettings({
            uiSettings: {
              bgColor: '#F8FAFC',
              mobileEmbed: true,
              application: {
                hideTitle: false
              }
            }
          })
        );

        this.store$.select(selectUISettings).subscribe(settings => {
          document.body.style.backgroundColor = settings?.bgColor || '#F8FAFC';
          document.documentElement.style.backgroundColor = settings?.bgColor || '#F8FAFC';
        });
        return;
      }
      case !!SessionService.GetUISettings()?.mobileEmbed: {
        return;
      }
      case this.fromMobile === 'true': {
        return;
      }
      default: {
        this.downloadAppDialog?.show();
      }
    }
  }

  public ngOnInit(): void {
    this.handleRouteParams();
  }

}
